import { useEffect, useState } from "react";
import axios from "../api/axiosInstance";

function AdminDelUserModal({ open, user, onClose, onSuccess }) {
    const [form, setForm] = useState({ account: "", password: "" });
    const [loading, setLoading] = useState(false);

    // 每次打開或 user 變更時，重置表單
    useEffect(() => {
        if (open && user) {
            setForm({ account: user.account ?? "", password: "" });
        }
    }, [open, user]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    function getAxiosErrorMessage(error) {
        // 有回應（HTTP 4xx/5xx）
        if (error?.response) {
            const data = error.response.data;
            // 可能是字串（例如 NotFound("...")）
            if (typeof data === "string") return data;
            // 可能是物件（ProblemDetails 或自定 JSON）
            if (data?.detail) return data.detail;     // RFC7807 ProblemDetails
            if (data?.title) return data.title;       // ProblemDetails title
            if (data?.message) return data.message;   // 自定 { message: "..." }
            try {
                return JSON.stringify(data);
            } catch { /* ignore */ }
        }
        // 沒有回應（網路錯誤/被中斷）
        return error?.message || "發生未知錯誤";
    }


    const handleDelete = async () => {
        if (!user) return;
        if (!window.confirm("確定要註銷？")) return;

        try {
            setLoading(true);
            const token = localStorage.getItem("token");
            await axios.delete("/api/Admin", {
                headers: { Authorization: `Bearer ${token}` },
                data: form, // DELETE 的 body 要放在 config.data
            });
            if (onSuccess) onSuccess();
            alert("註銷成功");
            // 成功後重置並關閉
            setForm({ account: user.account ?? "", password: "" });
            onClose?.();
        } catch (err) {
            const msg = getAxiosErrorMessage(err);
            alert(msg || "註銷失敗");
        } finally {
            setLoading(false);
        }
    };

    if (!open || !user) return null;

    return (
        <>
            <div className="modal show fade d-block" tabIndex="-1" role="dialog" style={{ zIndex: 1055 }}>
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">註銷使用者</h5>
                            <button type="button" className="btn-close" onClick={onClose} disabled={loading}></button>
                        </div>
                        <div className="modal-body">
                            <div className="mb-2">
                                <label className="form-label">使用者帳號</label>
                                <div>{user.account}</div>
                            </div>
                            <div className="mb-2">
                                <label className="form-label">使用者名稱</label>
                                <div>{user.name}</div>
                            </div>
                            <div className="mb-2">
                                <label className="form-label">註銷密碼</label>
                                <input
                                    type="password"
                                    className="form-control mb-2"
                                    name="password"
                                    value={form.password}
                                    onChange={handleChange}
                                    disabled={loading}
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={onClose} disabled={loading}>取消</button>
                            <button
                                className="btn btn-outline-danger btn-sm"
                                onClick={handleDelete}
                                disabled={!form.password || loading}  // 無密碼或載入中禁用
                            >
                                {loading ? "處理中..." : "註銷使用者"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show" style={{ zIndex: 1050 }}></div>
        </>
    );
}

export default AdminDelUserModal;
